export default "__VITE_ASSET__CUbOtakg__"